let _ = require('lodash');
export function login(username,password){
    if(username.length <=4){
       return{
           feedback:'Username must be more than 4 characters',
           status:false
       }
    }else if(password.length <=3){
        return{
            feedback:'Password must be more than 3 characters',
            status:false
        }
     }else if(username.length >20){
            return{
                feedback:'Username must be less than 20 characters',
                status:false
            }
        
        }else{
            return{
                status:true
            }
        }
}

export function checkright(array,value){
    let result = _.includes(array,value);
    return result;
}

export function specify(array,prop,val){
    let result = array.filter( obj => {
            return obj[prop] == val;
    });
    return result;
}

export function loadCampus(camps,value){
 let camp = camps;
 console.log(camp);
  let length = value.length;
  for(let i=0;i<length;i++){
    camp.push(value[i].name)
    
    if((i+1)== value.length){
        console.log(camp);
          return camp;
          
      }
  }
}

export function loadCategory(value){
    let cats = [];
    console.log(cats);
     let length = value.length;
     for(let i=0;i<length;i++){
       cats.push(value[i].name)
       
       if((i+1)== value.length){
           console.log(cats);
             return cats;
             
         }
     }
   }

   export function loadMovie(name,value){
    let mov = [];
    let ret =  specify(value,'category',name)
     console.log(ret);
     let length = ret.length;
     for(let i=0;i<length;i++){
       mov.push(ret[i].movName)
       
       if((i+1)== ret.length){
           return mov;  
             
         }
     }
   }
   
export function trim(value){
    String.prototype.trimAll = function(){
        return this.replace(/\s+/g,"");
    }

    let trimmed = value.trimAll();
    console.log("Trimmed to: ",trimmed);
    return trimmed;
}
export function generateId(ini){
    let alpha = ['aPi','bQj','cqt','dze','e','af','g','hP','x','lM9']
    let result = ini+'_'+ new Date().getTime()+alpha[Math.floor(Math.random()*9)]+Math.floor(Math.random() * (1035-987) + 87)+alpha[Math.floor(Math.random()*9)];
    return result;
    }